<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <v-form ref="add_group" @submit.prevent="save_group">
          <div class="grid_half">
            <div class="pa-2">
              <div class="mt-4">
                <v-img height="200" max-width="200" v-if="imagePreviewURL == null" :lazy-src="img_holder" :src="img_holder" class="preview mx-auto"></v-img>
                <v-img height="200" max-width="200" v-if="imagePreviewURL != null" :src="imagePreviewURL" class="preview mx-auto"></v-img>
              </div>
              <div class="ml-3 mr-3">
                <v-file-input color="#86bc3a" label="รูปภาพสินค้า" prepend-icon="mdi-camera" :rules="[v => !!v || 'กรุณาเลือกไฟล์รูปภาพสินค้า']" hide-details="auto" v-model="pro_pic_name" @change="onFileChange"></v-file-input>
              </div>
            </div>
            <div class="pa-2">
              <div class="grid_list">
                <div class="ml-3 mt-6 mr-1">
                  <v-text-field color="#86bc3a" label="ชื่อโปรโมชั่น" :rules="[v => !!v || 'กรุณากรอกชื่อโปรโมชั่น']" v-model="send_data.name_group" hide-details="auto" outlined></v-text-field>
                </div>
                <div class="ml-3 mt-6 mr-1">
                  <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field color="#86bc3a" v-model="date" label="วันที่สิ้นสุดโปรโมชั่น (วัน/เดือน/ปี)" :rules="[v => !!v || 'กรุณากรอกวันที่สิ้นสุดโปรโมชั่น']" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                    </template>
                    <v-date-picker color="#86bc3a" @change="diffDateTH(dateEN)" v-model="dateEN" :min="start_date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="selectDate()">
                        ตกลง
                      </v-btn>
                      <v-btn text color="primary" @click="menu_date = false">
                        ยกเลิก
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
                <div class="ml-3  mr-1">
                  <v-text-field color="#86bc3a" @keypress="isOnlyNumber($event)" type="number" label="จำนวนในการคละ" min="0" v-model="send_data.qty_group" :rules="[v => !!v || 'กรุณากรอกจำนวนในการคละ']" hide-details="auto" outlined></v-text-field>
                </div>
                <div class="ml-3  mr-1">
                  <v-text-field color="#86bc3a" @keypress="isCurrency($event, send_data.price_group)" type="number" label="ราคาขาย(ต่อชุด)" min="0" v-model="send_data.price_group" :rules="[v => !!v || 'กรุณากรอกราคาขาย(ต่อชุด)']" hide-details="auto" outlined></v-text-field>
                </div>
                <div class="ml-3 mt-7 mr-1">
                  <v-select color="#86bc3a" :items="promotion_list" item-text="show_promotion_name" item-value="show_promotion_id" :rules="[v => !!v || 'กรุณาเลือกสถานะแสดงการขาย']" v-model="send_data.show_promotion_set" label="สถานะแสดงการขาย" hide-details="auto" required outlined/>
                </div>
              </div>
              <div class="grid_full">
                <div class="ml-3 mt-7 mr-1">
                  <v-textarea color="#86bc3a" label="รายละเอียด" :rules="[v => !!v || 'กรุณากรอกรายละเอียด']" v-model="send_data.note_group" hide-details="auto" outlined></v-textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="pa-4">
            <v-card-title>
              <div>
                สินค้าในเงื่อนไข
              </div>
            </v-card-title>
            <v-card-title>
              <v-autocomplete @input="addProductList()" color="#86bc3a" :items="getProduct" item-text="product_name" item-value="warehouse_id" v-model="send_data.select_product" prepend-inner-icon="mdi-cart-outline" label="สินค้า" hide-details="auto" outlined/>
            </v-card-title>
            <v-data-table :headers="headers" :items="data_list" :footer-props="footer_Props" :items-per-page="perPage" mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td>{{ dataDetail.item.product_name }}</td>
                  <td>
                    <div>{{ dataDetail.item.quantity }}</div>
                  </td>
                  <td>{{ dataDetail.item.unit }}</td>
                  <td>{{ format_price(dataDetail.item.cost_avg) }}</td>
                  <td class="pa-3">
                    <v-btn small height="42" @click="deleteProduct(dataDetail.item.warehouse_id)" class="grad-danger-bg white--text mb-1">
                      <v-icon>mdi-delete-empty-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <div class="text-center mt-4 pb-4">
              <v-btn height="45" class="white--text grad-success-bg btn_size" type="submit">บันทึกข้อมูล</v-btn>
            </div>
          </div>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script src="@/previewimage.js"></script>
<script>
import img_holder from "@/assets/pharmacy.png";
import {HTTP} from "@/axios";
import {formatPrice, minDate, onlyForCurrency, onlyForNumber} from "@/js/handler";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Promotion_add_group",
  data() {
    return {
      loading_page: false,
      search: '',
      perPage: -1,
      img_holder: img_holder,
      pro_pic_name: null,
      imagePreviewURL: null,
      menu_date: false,
      date: '',
      dateEN: '',
      start_date: this.min_date(),
      alert_success: false,
      alert_danger: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      promotion_list: [
        {
          show_promotion_id: 1,
          show_promotion_name: 'แสดงทั้งขายปลีก , ขายส่ง',
        },
        {
          show_promotion_id: 2,
          show_promotion_name: 'แสดงเฉพาะขายปลีก',
        },
        {
          show_promotion_id: 3,
          show_promotion_name: 'แสดงเฉพาะขายส่ง',
        },
      ],
      send_data: {
        select_product: null,
        name_group: '',
        qty_group: null,
        price_group: null,
        note_group: '-',
        show_promotion_set: null,
      },
      headers: [
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '350px',
        },
        {
          text: 'จำนวนคงเหลือ',
          value: 'quantity',
          fixed: true,
          width: '200px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit',
          fixed: true,
          width: '150',
        },
        {
          text: 'ราคาต้นทุนเฉลี่ย',
          value: 'cost_avg',
          fixed: true,
          width: '200px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '100px',
        },
      ],
      data_list: [],
      Product_id: 0,
      items: [
        {id: 1, name: 'อีโนรสส้ม'},
        {id: 2, name: 'อีโนรสมะนาว'},
        {id: 3, name: 'อีโนรสสตอเบอรี่'},
      ],
      getProduct: [],
      selected_arr: [],
    }
  },
  methods: {
    min_date: function () {
      return minDate()
    },
    async selectDate() {
      this.$refs.menu_date.save(this.date)
      this.menu_date = false
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const final_date = day+'-'+month+'-'+year
      return this.date = final_date
    },
    diffDateEN() {
      const diff = this.date.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year+'-'+month+'-'+day
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    onFileChange(payload) {
      const file = payload
      let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
      let file_ext = file.name;
      let ext = file_ext.split('.').pop().toLowerCase();
      if (parseInt(extall.indexOf(ext)) < 0) {
        Swal.fire({
          text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.imagePreviewURL = null
          this.pro_pic_name = null
        })
      }else {
        if (file) {
          this.imagePreviewURL = URL.createObjectURL(file)
          URL.revokeObjectURL(file)
        } else {
          this.imagePreviewURL = null
          this.pro_pic_name = null
        }
      }
    },
    get_product() {
      this.loading_page = true
      HTTP.post('/inventory/promotions/sets/getproducts')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.getProduct = res.data.object
              const pro_id = this.getProduct.map((detail) => {
                return detail.warehouse_id
              })
              this.selected_arr = pro_id
            }
          })
    },
    get_product_list() {
      this.getProduct = []
      HTTP.post('/inventory/promotions/sets/getproducts')
          .then((res) => {
            if (res.data.success === true) {
              res.data.object.forEach((data) => {
                let inc = this.selected_arr.includes(data.warehouse_id)
                if (inc === true) {
                  this.getProduct.push({
                    cost: data.cost,
                    cost_avg: data.cost_avg,
                    created_at: data.created_at,
                    date_expired: data.date_expired,
                    discount_percent: data.discount_percent,
                    discount_price: data.discount_price,
                    discount_unit: data.discount_unit,
                    exchange_status: data.exchange_status,
                    import_id: data.import_id,
                    lot_no: data.lot_no,
                    po_id: data.po_id,
                    price: data.price,
                    product_code: data.product_code,
                    product_id: data.product_id,
                    product_name: data.product_name,
                    quantity: data.quantity,
                    status: data.status,
                    supplier: data.supplier,
                    supplier_id: data.supplier_id,
                    unit: data.unit,
                    unit_id: data.unit_id,
                    warehouse_id: data.warehouse_id,
                  })
                }
              })
            }
          })
    },
    async addProductList() {
      const res_1 = this.getProduct.filter((details) => {
        return details.warehouse_id === this.send_data.select_product
      })
      this.alert_success = true;
      setTimeout(() => this.alert_success = false, 3000);
      res_1.forEach((data) => {
        let loop_id = this.Product_id += 1;
        this.data_list.push({
          loop_id: loop_id,
          po_id: data.po_id,
          product_id: data.product_id,
          product_name: data.product_name,
          quantity: data.quantity,
          cost_avg: data.cost_avg,
          unit: data.unit,
          unit_id: data.unit_id,
          warehouse_id: data.warehouse_id,
          import_id: data.import_id,
        })
      })
      const find_product = this.data_list.filter(data => data.warehouse_id === this.send_data.select_product)
      const map_product = find_product.map(data => data.warehouse_id)
      const pop_id = map_product.pop()
      const index = this.selected_arr.indexOf(pop_id);
      if (index > -1) {
        this.selected_arr.splice(index, 1);
      }
      this.get_product_list()
      await this.$nextTick(() => {
        this.send_data.select_product = null
      })
    },
    deleteProduct(warehouse_id) {
      this.selected_arr.push(warehouse_id)
      this.data_list = this.data_list.filter(detail => detail.warehouse_id !== warehouse_id);
      this.get_product_list()
      this.send_data.select_product = null
      this.alert_danger = true;
      setTimeout(() => this.alert_danger = false, 2000);
    },
    save_group() {
      if (this.$refs.add_group.validate()) {
        if (this.data_list.length > 0) {
          let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
          let file = this.pro_pic_name.name;
          let ext = file.split('.').pop().toLowerCase();
          if (parseInt(extall.indexOf(ext)) < 0) {
            Swal.fire({
              text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then(() => {
              this.imagePreviewURL = null
              this.pro_pic_name = null
            })
          }
          else {
            let config = {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            };
            let formData = new FormData();
            formData.append('image', this.pro_pic_name, this.pro_pic_name.name)
            formData.append('user_id', this.$store.state.userDetail.id)
            formData.append('user_name', this.$store.state.userDetail.name)
            formData.append('promotion_group_date', this.diffDateEN())
            formData.append('name_group', this.send_data.name_group)
            formData.append('qty_group', this.send_data.qty_group)
            formData.append('price_group', this.send_data.price_group)
            formData.append('note_group', this.send_data.note_group)
            formData.append('show_promotion_set', this.send_data.show_promotion_set)
            formData.append('data_list', JSON.stringify(this.data_list))
            this.overlay = true
            this.image_modal = false
            HTTP.post('/inventory/promotions/sets/create', formData, config)
                .then((res) => {
                  if (res.data.success === true) {
                    Swal.fire({
                      text: 'บันทึกข้อมูลเรียบร้อย !',
                      icon: 'success',
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: `ตกลง`,
                      denyButtonText: `ยกเลิก`,
                    }).then(() => {
                      this.$router.push('/stock/promotion_stock/promotionassorted')
                    })
                  }
                })
          }
        }
        else {
          Swal.fire({
            title: 'ไม่สามารถดำเนินการได้ !',
            text: 'เนื่องจาก ไม่มีข้อมูลหรือไม่ได้เลือกสินค้า !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          })
        }
      }
    }
  },
  mounted() {
    this.get_product()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.grid_half {
  display: grid;
  grid-template-columns: 30% 70%;
}
.grid_list {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}
.btn_size {
  font-size: 18px;
}
.preview {
  border-radius: 8px;
}
@media only screen and (max-width: 1100px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_list {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_full {
    display: grid;
    grid-template-columns: 100%;
    margin-top: 40px;
  }
}
</style>
